// **********************************************************
// Close Popup When Escape Key Press
// **********************************************************

document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') {
    const modalElem = document.querySelectorAll('.modal');

    modalElem.forEach((el) => {
      el.classList.remove('is-open-modal');
      toggleBodyScrollLock(false);
    });
  }
});

// **********************************************************
// Close Popup When Click On Outside
// **********************************************************

attachEvent('.modal__close,.modal__overlay', 'click', (ev) => {
  const parentEle = ev.target.closest('.modal');
  parentEle.classList.remove('is-open-modal');
  toggleBodyScrollLock(false);
  ev.preventDefault();
});

// **********************************************************
// Open Modal
// **********************************************************

attachEvent('[data-modal-trigger]', 'click', (ev) => {
  const parentEle = ev.target.closest('[data-modal-parent]');
  const modalEle = parentEle.querySelector('.modal');

  if (modalEle) {
    modalEle.classList.add('is-open-modal');
    toggleBodyScrollLock(true);
    ev.preventDefault();
  }
});

// **********************************************************
//  Modal Slider
// **********************************************************

const modalSlider = document.querySelectorAll('[data-slider="modal__slider"]');

const getModalSliderDirection = () => {
  const direction = windowWidth() <= breakpointMd ? 'horizontal' : 'vertical';
  return direction;
};

const modalSliderOptions = {
  slidesPerView: 1,
  spaceBetween: 0,
  slidesPerGroupSkip: 1,
  direction: getModalSliderDirection(),
  scrollbar: {
    el: '.swiper-scrollbar',
    draggable: true,
    enabled: true,
  },
  watchOverflow: true,
  speed: 600,
  mousewheel: false,
  effect: 'fade',
  fadeEffect: {
    crossFade: true,
  },
  breakpoints: {
    1023: {
      mousewheel: {
        enabled: true,
        releaseOnEdges: true,
      },
    },
  },
  on: {
    resize: (ele) => {
      ele.changeDirection(getModalSliderDirection());
    },
  },
};

modalSlider.forEach((el) => {
  new Swiper(el, modalSliderOptions);
});
